import { AdminService } from 'admin/store/service';
import { B64File } from 'common/classes/B64File.class';
/**
 * Thématique du forum
 */
export class Thematique {
    /**
     * Constructeur de la thématique
     * @param thematique à construire
     */
    constructor(thematique) {
        if (thematique) {
            const { idForumThematique, idPere, libelleThematique, file, urlImage, descriptif, dateEnregistrementThematique, actif, ordreThematique, idAuteurSuppression, idRaisonSuppression, dateSuppression, nbMessage, nbDiscussion, children, } = thematique;
            this.idForumThematique = idForumThematique;
            this.idPere = idPere;
            this.libelleThematique = libelleThematique;
            this.file = file ? new B64File(file) : urlImage ? new B64File(B64File.pathUrlToFile(urlImage)) : null;
            this.descriptif = descriptif;
            this.dateEnregistrementThematique = dateEnregistrementThematique;
            this.actif = actif;
            this.ordreThematique = ordreThematique;
            this.idAuteurSuppression = idAuteurSuppression;
            this.idRaisonSuppression = idRaisonSuppression;
            this.dateSuppression = dateSuppression;
            this.children = children === null ? null : children === null || children === void 0 ? void 0 : children.map((child) => new Thematique(child));
            this.nbMessage = nbMessage;
            this.nbDiscussion = nbDiscussion;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idForumThematique: this.idForumThematique,
            idPere: this.idPere,
            libelleThematique: this.libelleThematique,
            descriptif: this.descriptif,
            file: this.file.toRaw(),
            dateEnregistrementThematique: this.dateEnregistrementThematique,
            actif: this.actif,
            ordreThematique: this.ordreThematique,
            idAuteurSuppression: this.idAuteurSuppression,
            idRaisonSuppression: this.idRaisonSuppression,
            dateSuppression: this.dateSuppression,
            nbMessage: this.nbMessage,
            nbDiscussion: this.nbDiscussion,
        };
    }
    /**
     * Ajoute ou met à jour une thématique en BDD
     * @return tru si action réussie, false sinon
     */
    save() {
        return AdminService.addForumThematique(this.toRaw());
    }
    /**
     * Supprime une thématique en BDD
     * @return true si action réussie, false sinon
     */
    delete() {
        return AdminService.deleteThematique({
            idThematique: this.idForumThematique,
            idAuteurSuppression: this.idAuteurSuppression,
            idRaisonSuppression: this.idRaisonSuppression,
            actif: this.actif,
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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